/* eslint-disable prettier/prettier */
import moment from 'moment';
import { useEffect, useState } from 'react';
import useHttpApiCall from '../../services/useHttpApiCall';

export default function RefreshHeatmap({
  data,
  payload2,
  charRef,
  chartApiData,
  setChartApiData,
  lastTimeStamp,
  setLastTimeStamp,
  graphApiCall,
  graphAddPointApiCall,
}) {
  const [checkOfflineCut, setCheckOfflineCut] = useState(false);
  // const EXTRATIME_TO_TRIGGER = 0 //Trigger the api after 30 seconds

  const EXTRATIME_TO_TRIGGER = chartApiData.point_interval == 300000 ? 30 * 1000 : 5000; //Trigger the api after 30 seconds
  const TIME_TO_TRIGGER = chartApiData.point_interval ? chartApiData.point_interval : 120000;
  let addPointApiTimer, loadingTimer, callEveryHour;

  const [data2, loading2, error2] = useHttpApiCall(payload2);

  useEffect(() => {
    if (!checkOfflineCut) {
      callEveryHour = setTimeout(
        () => {
          console.log('reload after 1hr');
          graphApiCall();
        },
        60 * 60 * 1000
      );
    }

    return () => {
      clearTimeout(callEveryHour);
    };
  }, [chartApiData]);

  const addPointApi = (triggertime, diffrenceTime) => {
    clearTimeout(loadingTimer);
    clearTimeout(addPointApiTimer);
    let timeOutTime = triggertime - diffrenceTime + EXTRATIME_TO_TRIGGER;
    console.log('Heatmap Api will be called after minutes', moment.utc(timeOutTime).format('HH:mm:ss'));
   
    addPointApiTimer = setTimeout(function () {
      console.log('point add called at', moment.utc().local().format('HH:mm:ss'));
      setCheckOfflineCut(true);
      graphAddPointApiCall();
    }, timeOutTime);
  };

  useEffect(() => {
    if (lastTimeStamp) {
      
      let lastTime = moment(lastTimeStamp);
      let diffrenceTime = moment().diff(lastTime); // Time left from current time to last updated
      console.log('difference time ', diffrenceTime, 'last time stamp', lastTimeStamp);

      if (diffrenceTime > TIME_TO_TRIGGER) {
        //console.log('difference time is more', diffrenceTime);
        diffrenceTime = TIME_TO_TRIGGER;
      }
      addPointApi(TIME_TO_TRIGGER, diffrenceTime);
    }
    return () => {
      clearTimeout(addPointApiTimer);
    };
  }, [lastTimeStamp, data]);

  useEffect(() => {
    if (data2 && data2.data) {
      let apiData = data2.data.data;
      let series = charRef.current.chart.series;
      console.log("enter inside the call",series,apiData.data_points.length)  

      if (apiData){
        setChartApiData((prev) => ({ ...prev, last_updated_time: apiData.last_updated_time }));
        setCheckOfflineCut(false);
        if (Array.isArray(apiData) && apiData.length == 0) {
          // array exists and is empty
          addPointApi(0, 0);
        } else if (apiData.data_points.length > 0) {
            apiData.data_points.forEach((data_point) => {
              series[0].addPoint(data_point , false, true);
            });
          setLastTimeStamp(apiData.last_updated_time);
        }
      }
      else{
        console.log("call original api")
        graphApiCall();
      }
    }
  }, [data2]);

  useEffect(() => {
    if (error2) {
      console.log('error case');
      addPointApi(0, 0);
    }
  }, [error2]);

  useEffect(() => {
    if (!loading2 && checkOfflineCut) {
      console.log('gone offline, trigger after', TIME_TO_TRIGGER);
      loadingTimer = setTimeout(function () {
        addPointApi(0, 0);
      }, TIME_TO_TRIGGER);
    }
    return () => {
      clearTimeout(loadingTimer);
    };
  }, [loading2]);

  return <></>;
}
